import { API_URL } from 'resources/api'

const GetFetch =  async (URI) => {
    const response = await fetch(API_URL + URI);
    return response.json();
}


export default GetFetch;